import Spinner from '@carvana/ds-spinner';
import React from 'react';
import styles from './checking-spinner.module.css';

const CheckingSpinner: React.FC = () => (
  <div className={styles.container}>
    <Spinner size={48} />
    <p className={styles.message}>Checking for requirements</p>
  </div>
);

export default CheckingSpinner;
